import consts               from 'shared/consts';
import * as LatLngType      from 'shared/types/LatLng';
import * as LegType         from 'shared/types/Leg';
import * as OrderType       from 'shared/types/Order';
import * as RouteType       from 'shared/types/Route';
import * as WSPayloadType   from 'shared/types/WSPayload';
import * as FixedRouteType  from 'shared/types/FixedRoute';
import * as VehicleType     from 'shared/types/Vehicle';
import * as hhmmUtil        from 'shared/utils/hhmm';
import safeAtan             from 'shared/utils/safeAtan';
import dayjs                from 'shared/utils/day-timezone';
import routeStyles          from './routeStyles';

import tectransit           from './TecTransit';

export interface Marker extends google.maps.Marker {
    garbage?        : boolean;
    clickListener?  : google.maps.MapsEventListener;
}

export interface InfoWindow extends google.maps.InfoWindow {
    closeTimer?     : any;
}

export interface MarkerProps {
    key             : string;
    latlng          : google.maps.LatLngLiteral;
    pickup_orders   : OrderType.Order[];
    dropoff_orders  : OrderType.Order[];
}

export default class MapVehicle {

    static readonly bus_icon_path     = `m10.163549,1.193142c-1.680038,0.16905 -3.018442,0.941852 -3.613288,2.084955c-0.329577,0.635951 -0.337615,0.696327 -0.357711,2.559906l-0.012058,1.650254l-0.542596,0.197225c-0.297423,0.108675 -0.586808,0.233451 -0.647096,0.277726c-0.152731,0.12075 -0.221058,0.317976 -0.188904,0.551426c0.048231,0.350176 0.040192,0.350176 0.683269,0.249551c0.309481,-0.0483 0.590827,-0.08855 0.627,-0.08855c0.068327,0 0.072346,0.322001 0.080385,5.743688c0.012058,5.389487 0.016077,5.755763 0.084404,5.876514c0.100481,0.189175 0.337615,0.402501 0.506423,0.462876c0.209,0.076475 7.83348,0.076475 8.04248,0c0.164788,-0.05635 0.413981,-0.285776 0.514461,-0.466901c0.064308,-0.116725 0.068327,-0.571551 0.080385,-5.872489c0.008038,-5.421687 0.012058,-5.743688 0.080385,-5.743688c0.036173,0 0.317519,0.04025 0.627,0.08855c0.639058,0.10465 0.635038,0.10465 0.683269,-0.249551c0.032154,-0.233451 -0.036173,-0.430676 -0.188904,-0.551426c-0.060288,-0.044275 -0.349673,-0.16905 -0.651115,-0.277726l-0.542596,-0.197225l0,-1.473153c0,-1.143103 -0.012058,-1.553654 -0.060288,-1.827354c-0.289385,-1.654279 -1.792577,-2.785306 -3.995115,-2.998632c-0.47025,-0.044275 -0.719442,-0.044275 -1.209788,0.004025zm-1.527308,1.082727c0.128615,0.068425 0.132635,0.245526 0.020096,0.591676c-0.132635,0.394451 -0.325558,0.756702 -0.454173,0.861352c-0.273308,0.213325 -0.811885,-0.052325 -0.811885,-0.410551c0,-0.241501 0.466231,-0.764752 0.860115,-0.961977c0.265269,-0.132825 0.281346,-0.13685 0.385846,-0.0805zm4.794942,0.1127c0.26125,0.140875 0.695327,0.603751 0.755615,0.809027c0.040192,0.13685 0.036173,0.1771 -0.032154,0.309926c-0.144692,0.277726 -0.530538,0.386401 -0.755615,0.2093c-0.176846,-0.140875 -0.538577,-0.978077 -0.542596,-1.251778c0,-0.036225 0.036173,-0.10465 0.080385,-0.148925c0.096462,-0.0966 0.204981,-0.0805 0.494365,0.07245zm-1.177634,2.724931c0.570731,0.0805 1.189692,0.241501 1.579558,0.406526c0.341635,0.140875 0.631019,0.313951 0.631019,0.374326c0,0.044275 -0.719442,1.622079 -0.759635,1.666354c-0.016077,0.0161 -0.112538,-0.00805 -0.213019,-0.052325c-0.546615,-0.241501 -1.483096,-0.370301 -2.684846,-0.370301c-1.20175,0 -2.138231,0.1288 -2.684846,0.370301c-0.100481,0.044275 -0.196942,0.068425 -0.213019,0.052325c-0.068327,-0.07245 -0.759635,-1.642204 -0.743558,-1.686479c0.028135,-0.068425 0.337615,-0.245526 0.667192,-0.382376c0.502404,-0.20125 1.382615,-0.386401 2.190481,-0.454826c0.389865,-0.0322 1.812673,0.0161 2.230673,0.076475z`;
    static readonly pickup_icon_path  = "M12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z";
    static readonly dropoff_icon_path = "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z";
    static readonly boundaryColors    = [
        "black",
        "red",
        "green",
        "blue",
        "yellow",
        "pink",
        "orange",
        "salmon",
        "coral",
        "tomato",
        "darkgyan",
        "gold",
        "violet",
        "plum",
        "fuscia",
        "magenta",
        "purple",
        "indigo",
        "lime",
        "olive",
        "teal",
        "aqua",
        "cyan",
        "navy",
        "maroon",
        "silver",
        "gray",
        "darkgoldenrod",
        "darksalmon",
        "darkviolet"
    ];

    /////////////////////////////////////////////////////////////////
    // private/protected interface
    /////////////////////////////////////////////////////////////////
    // TODO:
    // Directions.Route has last_locations.
    // Server Route.ts fills it out only if route vehicle reports geo location.
    // Perhaps we can change the server to fill it out always and use it here
    private lastLocations    : google.maps.LatLngLiteral[] = [{lat:0,lng:0}];   // Last known locations of the vehicle, defaulting from [0,0]
    private lastRadians      : number = 0;                                      // Rotation should be alinged with the direction the vehicle is going
    private directionMarkers : Record<string,Marker> ={};                       // Markers along the path (pickups and dropoffs)
    private infoWindowsCount : number = 0;
    private circles          : google.maps.Circle[] = [];
    private polyline         : google.maps.Polyline;    // Path along which the vehicle is going
    private googleMap        : google.maps.Map;         // GoogleMap where the vehicle is shown
    private color            : string = '#ff0000';

    private static getDistinctMarkerProps( route:RouteType.Route ) : MarkerProps[] {
        const markerPropsByKey = (route.legs||[]).reduce( (markerPropsByKey,leg) => {
            return [
                {
                    key            : tectransit.getLatLngKey(leg.pickup.latlng!),
                    latlng         : leg.pickup.latlng!,
                    pickup_orders  : (leg.pickup.orders||[]).filter(o=>!o.pickup.at),
                    dropoff_orders : []
                },
                {
                    key            : tectransit.getLatLngKey(leg.dropoff.latlng!),
                    latlng         : leg.dropoff.latlng!,
                    pickup_orders  : [],
                    dropoff_orders : (leg.dropoff.orders||[]).filter(o=>!o.dropoff.at)
                }
            ].reduce( (markerPropsByKey,props) => {
                if( (props.key in markerPropsByKey) ) {
                    const props2 = markerPropsByKey[props.key];
                    props2.pickup_orders  = [...props2.pickup_orders,...props.pickup_orders];
                    props2.dropoff_orders = [...props2.dropoff_orders,...props.dropoff_orders];
                }
                else {
                    markerPropsByKey[props.key] = props;
                }
                return markerPropsByKey;
            },markerPropsByKey);
        },{} as Record<string,MarkerProps>);
        // Return only those props that have at least 1 order
        return Object.values(markerPropsByKey).filter(props=>((props.pickup_orders.length+props.dropoff_orders.length)>0));
    }
    // These are meant to be overloaded by subclasses
    protected describeOrder(o:OrderType.Order,event:OrderType.Event) {
        // This method defines what users get to see when they click on a marker on a map
        // * The passenger will see just the orders description
        // * The dispatcher should be able to re-schedule orders
        // The default implementation makes sense for the passenger and - perhaps - driver
        // The dispatchers need to overload this method.
        return `<b>#${o._id}</b> from user <b>${o.user!.name} at ${dayjs(event.eta!).tz(tectransit.agency.time_zone).format(tectransit.timeFormat)}</b><br>${event.address}`;
    }
    protected getOrdersDescription( orders:OrderType.Order[], descriptor:string, order_event_getter:(order:OrderType.Order)=>OrderType.Event ) {
        if( orders.length===0 )
            return {
                content : ''
            };
        if( orders.length===1 )
            return {
                title   : `${descriptor} of order #${orders[0]._id} from user ${orders[0].user?orders[0].user.name:('#'+orders[0].user_id)}`,
                content : `${descriptor} of `+this.describeOrder(orders[0],order_event_getter(orders[0]))+`</br>`
            };
        return {
            title   : `${descriptor} of ${orders.length} orders`,
            content : `<b>${descriptor}s:</b><ol><li>`+orders.map(o=>this.describeOrder(o,order_event_getter(o))).join('</li><li>')+`</li></ol></br>`
        };
    }
    protected getLegs() : LegType.Leg[] {
        return this.serverVehicle.route.legs||[];
    }
    protected getPolylinePath() : google.maps.LatLng[] {
        this.circles.forEach( c => {
            c.setMap(null);
        });
        this.circles = [];
        return this.getLegs().map( l => {
            // Draw small circles at the end of each step and larger circle as the end of each leg
            const points = l.steps.map( s => {
                const points = google.maps.geometry.encoding.decodePath(s.polyline.points);
                this.circles.push(new google.maps.Circle({
                    strokeWeight  : 2,
                    strokeColor   : this.color,
                    map           : this.googleMap,
                    center        : points.at(-1),
                    radius        : 4
                }));
                return points;
            }).flat();
            this.circles.push(new google.maps.Circle({
                strokeWeight  : 2,
                strokeColor   : this.color,
                map           : this.googleMap,
                center        : points.at(-1),
                radius        : 8
            }));
            return points;
        }).flat();
    }
    protected getGpsLatLng() : (VehicleType.ReportedLocation|undefined) {
        // Can be overloaded in subclasses
        // If the last time we got a location from vehicle was more than
        // `tectransit.agency.max_lateness_seconds` ago then do not use it
        if( ((Date.now()/1000)-tectransit.agency.max_lateness_seconds)>(this.serverVehicle.reported_location?.seconds||0) )
            return undefined;
        return this.serverVehicle.reported_location;
    }
    protected getRouteLatLng() : (LatLngType.LatLng|undefined) {
        const route = this.serverVehicle?.route;
        if( !route )
            return undefined;
        return (route.legs||[]).map(l=>l.steps).flat().map(s=>s.start_location).find(ll=>!!ll) || route.last_locations?.at(-1);
    }
    protected getScale() : number {
        return 1;
    }
    private getRadians( latLng:LatLngType.LatLng ) : number {
        if( this.lastLocations.length>2 )
            this.lastLocations.shift();
        this.lastLocations.push(latLng);
        const lastLatLng = this.lastLocations.at(-1)!;
        const prevLatLng = this.lastLocations.at(-2)!;
        return this.lastRadians=(safeAtan(lastLatLng.lat-prevLatLng.lat,lastLatLng.lng-prevLatLng.lng)??this.lastRadians);
    }
    protected getSymbol( radians:number ) : google.maps.Symbol {
        return {
            fillColor     : this.color,
            fillOpacity   : 1,
            path          : MapVehicle.bus_icon_path, // TODO: change symbol path depending on the type of the vehicle
            rotation      : radians*consts.degrees_in_radian,
            scale         : this.getScale(),
            strokeColor   : this.color,
            strokeOpacity : 0
        };
    }
    protected getPositionFromLatLng( latLng:google.maps.LatLng, radians:number ) : google.maps.LatLng {
        // The center of the vehicle is located in the center of 22x22 square the top-left corner of which
        // consides with the location of this_leg.start_location (when rotated 0 degrees). Instead we need
        // the center of the vehicle to be on `latLng`. Therefore we need to have position of the
        // marker signifying the vehicle to be at some offsets from position of `latLng`.
        // The code below takes into account the current roation of the square and calculates the offsets
        const dimension     = (22*this.getScale())/Math.sqrt(2);
        const radians2      = radians+(Math.PI/4);
        const offsetX       = -dimension*Math.cos(radians2);
        const offsetY       = -dimension*Math.sin(radians2);
        const map           = this.googleMap;
        const projection    = map.getProjection()!;
        const scale         = Math.pow(2,map.getZoom()!);
        const worldLatLng   = projection.fromLatLngToPoint(latLng)!;
        return projection.fromPointToLatLng(new google.maps.Point(
            worldLatLng.x + offsetX/scale,
            worldLatLng.y + offsetY/scale
        ))!;
    }
    protected getVehicleTitle( location?:(LatLngType.LatLng&{seconds?:number}) ) : string {
        if( !this.serverVehicle )
            return `no vehicle`;
        const base             = `${this.serverVehicle.type||'Vehicle'} #${this.serverVehicle._id||0}`;
        const status           = this.serverVehicle.is_online ? 'online' : 'offline';
        const status_timestamp = dayjs(this.serverVehicle.is_online_changed_at||0).tz(tectransit.agency.time_zone).format("MM-DD-YYYY HH:mm");
        location ||= this.serverVehicle.reported_location;
        if( !this.serverVehicle.is_online || isNaN(location?.seconds!) )
            return `${base} ${status} since ${status_timestamp}`;
        return `${base} ${status} since ${status_timestamp}, location known at ${dayjs(location!.seconds!*1000).tz(tectransit.agency.time_zone).format("MM-DD-YYYY HH:mm")}`;
    }
    /////////////////////////////////////////////////////////////////
    // public interface
    /////////////////////////////////////////////////////////////////
    public vehicleMarker                : Marker;                            // Marker of the vehicle itself
    public serverVehicle                : WSPayloadType.Vehicle.Hydrated;    // This is the data the server sent us
    // For https://github.com/TecTransit/TecTransit/issues/359
    public frStop                       : FixedRouteType.Stop|undefined;
    public frStopArrivalLateSecs        : number = 0;
    public frStopDepartureEarlySecs     : number = 0;

    constructor( googleMap:google.maps.Map ) {
        this.googleMap     = googleMap;
        this.polyline      = new google.maps.Polyline({
            map         : googleMap,
            clickable   : false,
            draggable   : false,
            editable    : false,
            visible     : true
        });
        this.vehicleMarker = new google.maps.Marker({
            map   : googleMap,
            icon  : {
                path          : google.maps.SymbolPath.CIRCLE,
                strokeWeight  : 2,
                strokeColor   : "#FF0000",
                scale         : 10
            }
        });
        this.serverVehicle = {
            _id             : -1,
            type            : 'Bus',
            agency_id       : tectransit.agency._id,
            odometer_meters : 0,
            route           : {
                legs           : []
            }
        };
    }
    getVehicleColor( serverVehicle:WSPayloadType.Vehicle.Hydrated ) : string {
        // TODO:
        // Replace with getClosestBackgroundColor from Public/src/utils/FRState.ts
        if( MapVehicle.boundaryColors.includes(serverVehicle.fixed_route_id?.toLowerCase()||'') )
            return serverVehicle.fixed_route_id!;
        return routeStyles[serverVehicle._id % routeStyles.length].backgroundColor;
    }
    update( serverVehicle:WSPayloadType.Vehicle.Hydrated ) : boolean {
        this.serverVehicle  = serverVehicle;
        // If fixed route name is a color, then use this color
        this.color           = this.getVehicleColor(serverVehicle);
        // Let's draw some points on a map
        const polylinePath   = this.getPolylinePath();
        const gpsLatLng      = this.getGpsLatLng();
        const polyLineLatLng = polylinePath[0]?.toJSON();
        const routeLatLng    = this.getRouteLatLng();
        const latLng         = gpsLatLng || (tectransit.agency.simulate_reported_location?(routeLatLng||polyLineLatLng):undefined);
        if( latLng ) {
            this.move(latLng);
        }
        else if( tectransit.agency.simulate_reported_location ) {
            console.warn(`Vehicle ${serverVehicle._id}: cannot get vehicleLatLng,legs.length=${this.getLegs().length}`);
        }
        // Draw line
        this.polyline.setOptions({
            strokeColor : this.color,
            path        : polylinePath
        });
        this.updateMarkers();
        // Return true if we can re-scale the map
        return (this.infoWindowsCount===0);
    }
    updateFrStop( currentMmnt:dayjs.Dayjs ) : void {
        if( !this.serverVehicle.fixed_route_trip )
            return;
        const currentSeconds    = (currentMmnt.hour()*3600)+(currentMmnt.minute()*60)+currentMmnt.second();
        const currentStep       = this.serverVehicle.route.legs[0]?.steps[0];
        if( !currentStep ) {
            // Just skip it. The vehicle is not on a route or something
        }
        else if( currentStep.stop ) {
            // This is the "stop" step
            if( this.frStop!==currentStep.stop ) {
                this.frStop    = currentStep.stop;
                const stopArrivalSeconds = hhmmUtil.getSecondsFromHHmm(this.frStop.stop_time.arrival_time);
                this.frStopArrivalLateSecs     = currentSeconds-stopArrivalSeconds;
                this.frStopDepartureEarlySecs  = 0;
            }
        }
        else {
            // This is the "driving" step
            if( this.frStop ) {
                // We have just have left a stop by starting the driving step. Check if we are running hot.
                // We are running hot if started the driving step before the departure time of the last stop
                const stopDepartureSeconds = hhmmUtil.getSecondsFromHHmm(this.frStop.stop_time.departure_time);
                this.frStopArrivalLateSecs    = 0;
                this.frStopDepartureEarlySecs = stopDepartureSeconds-currentSeconds;
                this.frStop = undefined;
            }
        }
    }
    move( latLng:LatLngType.LatLng ) {
        const radians       = this.getRadians(latLng);
        this.vehicleMarker.setOptions({
            label       : `${this.serverVehicle?._id||0}`,
            title       : this.getVehicleTitle(latLng),
            position    : this.getPositionFromLatLng(new google.maps.LatLng(latLng),radians),
            icon        : this.getSymbol(radians)
        });
    }
    updateMarkers() {
        Object.values(this.directionMarkers).forEach(marker=>(marker.garbage=true));
        MapVehicle.getDistinctMarkerProps(this.serverVehicle.route).forEach( props => {
            if( !(props.key in this.directionMarkers) )
                this.directionMarkers[props.key] = new google.maps.Marker({
                    map      : this.googleMap,
                    position : new google.maps.LatLng(props.latlng)
                });
            const marker = this.directionMarkers[props.key];
            marker.garbage = false;
            marker.setIcon({
                fillColor     : this.color,
                fillOpacity   : 1,
                path          : props.dropoff_orders.length ? MapVehicle.dropoff_icon_path : MapVehicle.pickup_icon_path,
                strokeOpacity : 0,
                anchor        : new google.maps.Point(11,21)
            });
            const pickupsDescription  = this.getOrdersDescription(props.pickup_orders,"Pickup",o=>o.pickup);
            const dropoffsDescription = this.getOrdersDescription(props.dropoff_orders,"Dropoff",o=>o.dropoff);
            marker.setTitle([pickupsDescription.title,dropoffsDescription.title].filter(t=>t).join(' and '));
            if( marker.clickListener )
                marker.clickListener.remove();
            marker.clickListener = marker.addListener('click',() => {
                const infoWindow = (new google.maps.InfoWindow({content:(pickupsDescription.content+dropoffsDescription.content)})) as InfoWindow;
                infoWindow.open(this.googleMap,marker);
                this.infoWindowsCount++;
                infoWindow.closeTimer = setTimeout(() => {
                    // automatic close in 8 secs
                    infoWindow.close();
                    delete infoWindow.closeTimer;
                    this.infoWindowsCount--;
                },8000);
                infoWindow.addListener('closeclick',() => {
                    if( infoWindow.closeTimer ) {
                        clearTimeout(infoWindow.closeTimer);
                        delete infoWindow.closeTimer;
                        this.infoWindowsCount--;
                    }
                });
            });
        });
        Object.entries(this.directionMarkers).forEach( ([key,marker]) => {
            if( marker.garbage ) {
                marker.setMap(null);
                delete this.directionMarkers[key];
            }
        });
    }
    remove() {
        Object.values(this.directionMarkers).forEach(marker=>marker.setMap(null));
        this.directionMarkers = {};
        this.infoWindowsCount = 0;
        this.vehicleMarker.setMap(null);
        this.polyline.setMap(null);
        this.circles.forEach(c=>c.setMap(null));
        this.circles = [];
    }
    isCloseTo( ll:(LatLngType.LatLng|undefined), maxMetersAway:number) : boolean {
        if( !ll )
            return false;
        const currentLatLng = this.getGpsLatLng() || this.getRouteLatLng();
        if( !currentLatLng )
            return false;
        return LatLngType.getMetersBetween(currentLatLng,ll)<maxMetersAway;
    }
}
